import React from "react";
import { useTranslation } from "react-i18next";
import LegalPage from "./LegalPage";
import { cookiesContent } from "./legalContent";
import { openCookieSettings } from "../../utils/cookieConsent";
import { consentSecondaryClass } from "../cookies/consentStyles";

/**
 * /cookies — every cookie and similar technology the site uses, and the place
 * to change the answer given to the banner.
 *
 * The button sits right under the introduction: someone who opened this page
 * to withdraw consent should not have to read to the end to find out how.
 */
const Cookies = () => {
  const { t } = useTranslation();

  return (
    <LegalPage content={cookiesContent}>
      <div className="mt-6 sm:max-w-xs">
        <button
          type="button"
          onClick={openCookieSettings}
          className={`cookie-settings-open ${consentSecondaryClass}`}
        >
          {t("CookieConsent.changePreferences")}
        </button>
      </div>
    </LegalPage>
  );
};

export default Cookies;
